import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'

import HeaderNavBar from './HeaderNavBar';

import ProfileDropdown from '../components/ProfileDropdown';
import logo from '../images/LANDMARKS-ID-Logo-no-strap.svg';
import { logOut } from '../store/actions/auth-actions';
import { getCredentials } from '../utilities/localStorage';


const Header = props => {

  const checkExpireDate = () =>{
    const storedCredentials = getCredentials();
    const expiresAt = storedCredentials.expiresAt ;

    if (expiresAt < new Date().getTime()/1000) {

      dispatch(logOut())
    }

  }

  useEffect(() => {
    checkExpireDate()
  });

  const dispatch = useDispatch();
  const firstName =  useSelector(state => state.auth.firstName);
  return(
    <header className="Header">

        <img src={logo} alt="LANDMARKS ID" className="Header_logo" />

      <div className="Header_rigth">
        <HeaderNavBar />
        {props.children}
        <span className="Header_welcome-text">Welcome {firstName}</span>
        <ProfileDropdown logOut={()=> dispatch(logOut())} />
      </div>
    </header>
  );
}



Header.propTypes = {
  children: PropTypes.node,
};

Header.defaultProps = {
  children: null,
};

export default Header ;
